export var getSelectStyles = function (theme) { return ({
    borderRadius: theme.backrs.radius['radius-md'],
    backgroundColor: theme.backrs.colors['Colors/Background/bg-primary'],
    border: "1px solid ".concat(theme.backrs.colors['Colors/Foreground/fg-quaternary']),
    alignSelf: 'center',
    cursor: 'pointer',
    minHeight: 'unset',
    padding: 'unset',
    transition: 'all 0.3s ease-in-out',
    '& .MuiOutlinedInput-input': {
        paddingRight: "".concat(theme.backrs.spacing['spacing-none'], " !important"),
    },
    '& .MuiInputBase-root': {
        paddingRight: "".concat(theme.backrs.spacing['spacing-none'], " !important"),
    },
    '& .MuiSelect-select': {
        padding: theme.backrs.spacing['spacing-md'],
    },
    '& .MuiSelect-icon': {
        display: 'none',
    },
    '&:hover': {
        border: "1px solid ".concat(theme.backrs.colors['Colors/Foreground/fg-primary']),
        boxShadow: theme.backrs.shadows['shadow-lg'],
    },
    '&:focus': {
        border: "1px solid ".concat(theme.backrs.colors['Colors/Foreground/fg-primary']),
    },
    '&.Mui-focused': {
        outline: 'none',
        boxShadow: theme.backrs.shadows['shadow-lg'],
        border: "1px solid ".concat(theme.backrs.colors['Colors/Foreground/fg-primary']),
    },
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },
}); };
export var getSelectMenuPaperStyles = function (theme) { return ({
    mt: theme.backrs.spacing['spacing-md'],
    boxShadow: theme.backrs.shadows['shadow-xl'],
    border: "1px solid ".concat(theme.backrs.colors['Colors/Foreground/fg-primary']),
    borderRadius: theme.backrs.radius['radius-md'],
}); };
export var getMenuItemStyles = function (theme) { return ({
    '&.Mui-selected': {
        backgroundColor: theme.backrs.colors['Colors/Base/Transparent'],
        '&:hover': {
            backgroundColor: theme.backrs.colors['Colors/Base/Transparent'],
        },
    },
    '&.MuiMenuItem-root:hover': {
        backgroundColor: 'transparent !important',
    },
    '&.Mui-focusVisible': {
        backgroundColor: 'transparent !important',
    },
}); };
export var getMenuItemContentStyles = function (theme) { return ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.backrs.spacing['spacing-lg'],
    width: '100%',
}); };
export var getMenuItemIconStyles = function (isChecked, theme) { return ({
    width: '16px',
    height: '16px',
    backgroundColor: isChecked
        ? theme.backrs.colors['Colors/Background/bg-brand-solid']
        : 'transparent',
    borderRadius: theme.backrs.radius['radius-xs'],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: isChecked ? "1px solid ".concat(theme.backrs.colors['Colors/Base/Black']) : 'none',
}); };
